const isUndefined = (value) =>
  typeof value === 'undefined' || value === 'undefined';

export default isUndefined;
